export type { RawMaterialMasterProps } from './raw-material-master';
export * from './raw-material-master.routes';

export { default as RawMaterialMaster, default } from './raw-material-master';
